import DOMPurify from 'dompurify';

const sanitize = (html, config) =>
    DOMPurify.sanitize(html, Object.assign({ADD_ATTR: ['target', 'rel']}, config));

export default {sanitize};
